import React from 'react';
import RubriqLoadingSpinner from '../../components/RubriqLoadingSpinner';
import RubriqAbstractCard from './RubriqAbstractCard';
var RubriqAbstractList = function RubriqAbstractList(_ref) {
  var abstracts = _ref.abstracts,
    loading = _ref.loading;
  if (loading) {
    return /*#__PURE__*/React.createElement(RubriqLoadingSpinner, {
      text: "loading abstracts"
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column align-items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-3 w-100"
  }, abstracts.map(function (abstract) {
    return /*#__PURE__*/React.createElement(RubriqAbstractCard, {
      key: abstract.session,
      abstract: abstract
    });
  }))));
};
export default RubriqAbstractList;